<template>
  <LinkCard
    theme="light"
    :image="thumbnail"
    @click.native="$emit('select', value.value)"
    class="theme-card"
    :class="{ 'theme-card--active': active, 'theme-card--shrink': !Boolean(value.description) }"
    :icon="['fal', 'palette']"
  >
    <template #title>
      <h3>{{ value.label }}</h3>
      <div>{{ $t(value.description) }}</div>
    </template>
  </LinkCard>
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'

export default {
  props: {
    value: Object,
    active: Boolean,
  },
  computed: {
    isFavorite() {
      return Boolean((this.value.tags || []).find(({ id }) => id === 'favorite'))
    },

    thumbnail() {
      if ((this.value.tags || []).find(i => i.id === 'intern')) return
      return { src: `/images/themes/${this.value.value}.jpg`, alt: this.value.value, size: 'contain' }
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>

<style lang="scss">
.theme-card {
  border: 1px solid var(--secondary);

  align-items: center;

  &--active {
    box-shadow: 0 20px 20px -5px css-alpha('primary', 20%);
    border-color: var(--primary);
  }

  &:focus-visible {
    outline: 2px solid !important;
    outline-offset: 1px;
  }
  .link-card {
    &__image {
      width: initial;
      height: initial;

      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &__content {
      height: initial;
      position: relative;
      background: inherit !important;

      padding: 3rem;
      h3 {
        margin-bottom: 0.5rem;
      }
    }
  }
}
</style>
